<template>
  <ol class="pointer-list" :class="`pointer-list--${orientation}`">
    <!-- il pallino numerato è il ::before dell'item: il numero arriva dal contatore CSS -->
    <li
      v-for="(step, index) in steps"
      :key="index"
      class="pointer-list__item"
    >
      <div class="pointer-list__content">
        <p v-if="step.title" class="pointer-list__title">{{ step.title }}</p>
        <p v-if="step.text" class="pointer-list__text">{{ step.text }}</p>
      </div>
    </li>
  </ol>
</template>

<script>
  export default {
    name: 'pointer-list',

    props: {
      // elenco degli step, ognuno { title, text }; il numero è dato dalla posizione
      steps: {
        type: Array,
        default: () => [],
      },
      // 'vertical' = elenco in colonna, pallino piccolo a lato del testo
      // 'horizontal' = step affiancati su tre colonne, pallino grande sopra il testo
      orientation: {
        type: String,
        default: 'vertical',
        validator: (value) => ['vertical', 'horizontal'].indexOf(value) !== -1,
      },
    },
  };
</script>

<style lang="scss" scoped>

  .pointer-list {
    padding: 0;
    margin: 0;
    list-style: none;
    counter-reset: pointer;

    // pallino numerato: il numero è il contatore CSS, dimensione e spessore bordo
    // variano con l'orientamento
    &__item {
      counter-increment: pointer;

      &::before {
        display: inline-flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        font-weight: $vb-font-weight-semibold;
        line-height: 1;
        color: $white;
        content: counter(pointer);
        background-color: $primary;
        border: solid $gray-300;
        border-radius: 50%;
        box-shadow: 0 1px 2px -1px rgba($black, .3);
      }
    }

    &__title {
      margin: 0;
      color: $gray-900;
    }

    &__text {
      margin: ($grid-gutter-width / 3) 0 0;
      font-size: $font-size-md;
      color: $gray-800;
    }

    // elenco in colonna: pallino 32px a sinistra, label su una riga
    &--vertical {
      display: flex;
      flex-direction: column;
      row-gap: $grid-gutter-width / 3;

      .pointer-list__item {
        display: flex;
        align-items: center;

        &::before {
          width: 32px;
          height: 32px;
          margin-right: $grid-gutter-width / 2;
          font-size: $font-size-md;
          border-width: 2px;
        }
      }

      .pointer-list__title {
        font-size: $font-size-base;
      }
    }

    // step affiancati: pallino 48px sopra al testo, tutto centrato
    &--horizontal {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      row-gap: $grid-gutter-width;

      .pointer-list__item {
        display: flex;
        flex: 0 0 percentage(1/3);
        flex-direction: column;
        align-items: center;
        max-width: percentage(1/3);
        padding: 0 $grid-gutter-width / 2;
        text-align: center;

        &::before {
          width: 48px;
          height: 48px;
          font-size: $font-size-xl;
          border-width: 4px;
        }
      }

      .pointer-list__title {
        margin-top: $grid-gutter-width / 2;
        font-size: $font-size-lg;
        font-weight: $vb-font-weight-semibold;
      }

      // due colonne su tablet, colonna singola su mobile: tre step da 320px non ci stanno
      @include media-breakpoint-down(md) {
        .pointer-list__item {
          flex-basis: 50%;
          max-width: 50%;
        }
      }

      @include media-breakpoint-down(sm) {
        .pointer-list__item {
          flex-basis: 100%;
          max-width: 100%;
        }
      }
    }
  }
</style>